import { Injectable } from '@angular/core';

import axios from 'axios';

@Injectable()
export class ServiceProvider {

    private headers : any = {
        'Content-Type': 'application/json',
        "tokenaccess": "ZWRhMDE0NTQ5MGQ0NjNhMThjZmYyZDJiOGMxNGUyNGQ=",
        "authorizationtoken": "bDRoNnc5bzM="
    };
    private apiUrl: string = "https://api.redacaocomely.com.br";
    //private apiUrl: string = "http://localhost/redacaocomely-api";

    constructor() {

    }

    /**
     * Retorna a URL da API
     */
    public getApiUrl() {
        return this.apiUrl;
    }

    postData(dados: any, para: string, urlComplete: boolean = false) {
        let to: string = urlComplete ? para : this.apiUrl + para;
        return new Promise((resolve, reject) => {
            axios.post(to,dados,{
                headers: this.headers
            }).then(result => {
                resolve(result.data);
            }).catch(error => {
                reject(error);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/service/service.ts